import { SxProps, TableCell, TableRow, Typography } from '@mui/material';
import React from 'react';

export const defaultCellSx = { paddingY: 1, paddingX: 2, border: 0, backgroundColor: 'action.selected' };

export interface EnhancedTableCell {
	content: React.ReactNode | string;
	align?: 'center' | 'right' | 'left' | 'inherit' | 'justify';
	customSpan?: number;
	customSx?: SxProps;
	// Note: using this in conjunction with an onClick in the containing row may cause unexpected behaviour
	onClick?: React.MouseEventHandler<HTMLTableCellElement>;
	onKeyDown?: React.KeyboardEventHandler<HTMLTableCellElement>;
}

interface RowProps {
	cells: EnhancedTableCell[];
	rowName: string;
	footer?: EnhancedTableCell;
	// Note: using this in conjunction with an onClick in contained cells may cause unexpected behaviour
	onClick?: React.MouseEventHandler<HTMLTableRowElement>;
	testId?: string;
	rowRef?: React.MutableRefObject<null | HTMLTableRowElement>;
}

const EnhancedTableRow: React.FC<RowProps> = ({ cells, rowName, footer, onClick, testId, rowRef }) => {
	return (
		<>
			<TableRow hover onClick={onClick} data-testid={testId} ref={rowRef}>
				{cells.map((cell, idx) => {
					return (
						<TableCell
							key={`enhanced-table-${rowName}-column-${idx}`}
							align={cell.align}
							sx={cell.customSx ?? defaultCellSx}
							colSpan={cell.customSpan}
							onClick={cell.onClick}
							onKeyDown={cell.onKeyDown}
							tabIndex={0}
							id={`enhanced-table-${rowName}-column-${idx}`}
						>
							<Typography component={'div'}>{cell.content}</Typography>
						</TableCell>
					);
				})}
			</TableRow>
			{footer && (
				<TableRow>
					<TableCell
						align={footer.align}
						sx={footer.customSx ?? { padding: 0, paddingLeft: 8 }}
						colSpan={footer.customSpan ?? cells.length}
						onClick={footer.onClick}
						id={`enhanced-table-${rowName}-footer`}
					>
						<Typography component={'div'}>{footer.content}</Typography>
					</TableCell>
				</TableRow>
			)}
		</>
	);
};

export default EnhancedTableRow;
